import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { InputNumber, message as msg, Switch } from "antd";
import {
  getSetting,
  updateSetting,
  initSetting,
} from "../features/setting/settingSlice";
import { Button, Form } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Setting = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { setting, isError, updating, message, isUpdateSuccess } = useSelector(
    (state) => state.setting
  );

  /** Check for api error and call api for init data */
  useEffect(() => {
    dispatch(initSetting());
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }
    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Setting is updated successfully",
      });
    }

    dispatch(getSetting());
  }, [isError, message, messageApi, dispatch, isUpdateSuccess]);

  /** Set default values in form */
  useEffect(() => {
    if (setting) {
      form.setFieldsValue({
        termsAndConditions: setting?.termsAndConditions || "",
        userAgreement: setting?.userAgreement || "",
        privacyPolicy: setting?.privacyPolicy || "",
        SignUP: setting.SignUP || "",
        SafetySecurityPrivacy: setting.SafetySecurityPrivacy || "",
        hole_in_one_credits: setting.hole_in_one_credits || 0,
        hole_out_credits: setting.hole_out_credits || 0,
        enable_redem_code: Boolean(setting.enable_redem_code),
        enable_leaderboard: Boolean(setting.enable_leaderboard),
      });
    }
  }, [setting, form]);

  /** On submit call api */
  const onFinish = (values) => {
    const convertedValues = {
      ...values,
      // Ensure boolean value for enable_redem_code
      enable_redem_code: Boolean(values.enable_redem_code),
      enable_leaderboard: Boolean(values.enable_leaderboard),
    };
    dispatch(updateSetting(convertedValues));
  };

  /** If there is error on form submission */
  const onFinishFailed = (errorInfo) => {
    messageApi.open({
      type: "error",
      content: errorInfo.message || "Error on form submission",
    });
  };
  return (
    <>
      {contextHolder}
      <div>
        <h3 className="mb-4 title">Setting</h3>
        <div className="d-flex gap-3">
          <div className="d-flex flex-grow-1 bg-white p-3 roudned-3">
            <div className="p-4 bg-white rounded-3" style={{ width: "60%" }}>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                initialValues={{
                  restrictedWord:
                    setting?.restrictedWord || "hello hi how are you",
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  label="Terms and Conditions"
                  name="termsAndConditions"
                >
                  <ReactQuill
                    theme="snow"
                    style={{ height: "150px", marginBottom: "40px" }}
                  />
                </Form.Item>

                <Form.Item label="Privacy Policy" name="privacyPolicy">
                  <ReactQuill
                    theme="snow"
                    style={{ height: "150px", marginBottom: "40px" }}
                  />
                </Form.Item>

                <Form.Item label="User Agreement" name="userAgreement">
                  <ReactQuill
                    theme="snow"
                    style={{ height: "150px", marginBottom: "40px" }}
                  />
                </Form.Item>

                <Form.Item label="Signup" name="SignUP">
                  <ReactQuill
                    theme="snow"
                    style={{ height: "150px", marginBottom: "40px" }}
                  />
                </Form.Item>

                <Form.Item
                  label="Safety Security Privacy"
                  name="SafetySecurityPrivacy"
                >
                  <ReactQuill
                    theme="snow"
                    style={{ height: "150px", marginBottom: "40px" }}
                  />
                </Form.Item>


                <Form.Item
                  label="Hole In One shots on signup "
                  name="hole_in_one_credits"
                >
                  <InputNumber min={0} style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                  label="Hole Out credits on signup"
                  name="hole_out_credits"
                >
                  <InputNumber min={0} style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                  label="Enable Redem Code"
                  name="enable_redem_code"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>

                <Form.Item
                  label="Enable Leaderboard"
                  name="enable_leaderboard"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>

                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                >
                  <Button disabled={updating} type="primary" htmlType="submit">
                    {updating ? "Update ..." : "Update"}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
